$( document ).ready(function() {
  if($("#MainContent").find(".collection-hero img").length > 0 
     || $("#shopify-section-slideshow").find("img").length > 0
     || $("#MainContent").find(".index-section--hero video").length > 0
     || $("#MainContent").find(".shopify-section .hero-slideshow").length > 0){
      $("body").addClass('hasBanner');
      if(!$(".header-wrapper").hasClass('header-wrapper--sticky')){
        $(".header-wrapper").addClass('header-wrapper--sticky is-light');
      }
  }
});